import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import { getErrorEndOTP, getErrorMessage } from "app/shared/services/axios";
import {
  ITEMAUTOTOPUPBILLING,
  ITEMTRANSACTIONAUTO,
  RESPONSEAUTOVALIDCUSTOMER,
  RESPONSEBASE,
  RESPONSECREATEAUTO,
} from "app/shared/services/services-model.type";
import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchAutoBillingAuthService,
  fetchAutoBillingCreateService,
  fetchAutoBillingDeleteService,
  fetchAutoBillingListService,
  fetchAutoBillingTransactionService,
  fetchAutoBillingValidCustomerService,
} from "../services/auto-billing.service";
import {
  fetchAutoBillingAuthorizationFailure,
  fetchAutoBillingAuthorizationSuccess,
  fetchAutoBillingCreateFailure,
  fetchAutoBillingCreateSuccess,
  fetchAutoBillingValidCustomerFailure,
  fetchAutoBillingValidCustomerSuccess,
  fetchAutoBillingListFailure,
  fetchAutoBillingListSuccess,
  fetchAutoBillingDeleteFailure,
  fetchAutoBillingDeleteSuccess,
  fetchAutoBillingTransactionSuccess,
  fetchAutoBillingTransactionFailure,
} from "./actions";
import {
  FETCH_AUTO_BILLING_AUTHORIZATION_KEY_REQUEST,
  FETCH_AUTO_BILLING_VALID_CUSTOMER_REQUEST,
  FETCH_AUTO_BILLING_LIST_REQUEST,
  FETCH_AUTO_BILLING_DELETE_REQUEST,
  FETCH_AUTO_BILLING_CREATE_REQUEST,
  FETCH_AUTO_BILLING_TRANSACTION_REQUEST,
} from "./actions.type";
import {
  FetchAutoBillingAuthorizationRequest,
  FetchAutoBillingCreateRequest,
  FetchAutoBillingDeleteRequest,
  FetchAutoBillingTransactionRequest,
  FetchAutoBillingValidCustomerRequest,
} from "./types";

function* fetchAutoBillingListSaga() {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(fetchAutoBillingListService);
    console.log("fetchAutoBillingList info response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      const data: ITEMAUTOTOPUPBILLING[] = response?.data?.data;
      yield put(fetchAutoBillingListSuccess(data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchAutoBillingListFailure(msg));
  }
}

function* fetchAutoBillingDeleteSaga(action: FetchAutoBillingDeleteRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEAUTOVALIDCUSTOMER> = yield call(() => fetchAutoBillingDeleteService(action));
    console.log("fetchAutoBillingDelete info response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchAutoBillingDeleteSuccess(response?.data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchAutoBillingDeleteFailure(msg));
  }
}

function* fetchAutoBillingValidCustomerSaga(action: FetchAutoBillingValidCustomerRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEAUTOVALIDCUSTOMER> = yield call(() => fetchAutoBillingValidCustomerService(action));
    console.log("fetchAutoBillingValidCustomer response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchAutoBillingValidCustomerSuccess(response?.data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchAutoBillingValidCustomerFailure(msg));
  }
}

function* fetchAutoBillingCreateSaga(action: FetchAutoBillingCreateRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSECREATEAUTO> = yield call(() => fetchAutoBillingCreateService(action.payload));
    console.log("fetchAutoBillingConfirm response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchAutoBillingCreateSuccess(response?.data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchAutoBillingCreateFailure(msg));
  }
}

function* fetchAutoBillingAuthSaga(action: FetchAutoBillingAuthorizationRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<any> = yield call(() => fetchAutoBillingAuthService(action));
    console.log("fetchAutoBillingAuth response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchAutoBillingAuthorizationSuccess());
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchAutoBillingAuthorizationFailure(getErrorEndOTP(e), msg));
  }
}

function* fetchAutoBillingTransactionSaga(action: FetchAutoBillingTransactionRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchAutoBillingTransactionService(action));
    console.log("fetchAutoBillingList info response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      const data: ITEMTRANSACTIONAUTO[] = response?.data?.data;
      yield put(fetchAutoBillingTransactionSuccess(data));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchAutoBillingTransactionFailure(msg));
  }
}

function* autoBillingSaga() {
  yield all([
    takeLatest(FETCH_AUTO_BILLING_LIST_REQUEST, fetchAutoBillingListSaga),
    takeLatest(FETCH_AUTO_BILLING_DELETE_REQUEST, fetchAutoBillingDeleteSaga),
    takeLatest(FETCH_AUTO_BILLING_VALID_CUSTOMER_REQUEST, fetchAutoBillingValidCustomerSaga),
    takeLatest(FETCH_AUTO_BILLING_CREATE_REQUEST, fetchAutoBillingCreateSaga),
    takeLatest(FETCH_AUTO_BILLING_AUTHORIZATION_KEY_REQUEST, fetchAutoBillingAuthSaga),
    takeLatest(FETCH_AUTO_BILLING_TRANSACTION_REQUEST, fetchAutoBillingTransactionSaga),
  ]);
}

export default autoBillingSaga;
